import { CustomWishlistItem, WishList } from 'modules/shop/wishlist/types';
import { ClientPageType } from 'src/app/types';

interface GetWishlistItemGtmDataType {
  wishlist?: WishList;
  findItemCallback: (item: CustomWishlistItem) => void;
  pageType?: ClientPageType;
}

export const getWishlistItemGtmData = ({
  wishlist,
  findItemCallback,
  pageType,
}: GetWishlistItemGtmDataType) => {
  if (!wishlist) {
    return;
  }

  const wishlistItem = wishlist.items?.find(findItemCallback);
  const product = wishlistItem?.adaptedProduct;

  if (product) {
    const productPrice = product.price.withTax / 100;

    return {
      productId: product.referenceKey,
      productPrice,
      pageType,
    };
  }
};
